'use client';

import { StateCreator } from 'zustand';

interface CartPromoState {
    hasOrderGiveaway: boolean;
    orderGiveaway: PromoOrderGiveaway | null;
}

interface CartPromoActions {
    updateCartOrderGiveaway: (orderGiveaway: PromoOrderGiveaway) => void;
}

export type CartPromoSlice = CartPromoState & CartPromoActions;

export const createCartPromoSlice: StateCreator<
    CartPromoSlice,
    [],
    [],
    CartPromoSlice
> = (set) => ({
    hasOrderGiveaway: false,
    orderGiveaway: null,
    updateCartOrderGiveaway: (orderGiveaway) => {
        const { promos } = orderGiveaway;

        set({ orderGiveaway, hasOrderGiveaway: !!promos.length });
    },
});
